import React from 'react';
import { Button } from '../../../../../components'; //'../../../';

import classes from './selectedOptionsContent.module.css';
import getOptionType from '../../ProductOptions/getOptionType';
import SwatchList from '../../ProductOptions/swatchList';
import TileList from '../../ProductOptions/tileList';
import { useOption } from '@magento/peregrine/lib/talons/ProductOptions/useOption';

var SelectedOptionsContent = function SelectedOptionsContent(option) {
  var attribute_id = option.attribute_id,
      label = option.label,
      selectedValue = option.selectedValue,
      values = option.values,
      attribute_code = option.attribute_code;

  var getItemKey = function getItemKey(_ref) {
    var value_index = _ref.value_index;
    return value_index;
  }; // TODO: get an explicit field from the API
  // that identifies an attribute as a swatch


  var getListComponent = function getListComponent(attribute_code, values) {
    var optionType = getOptionType({
      attribute_code: attribute_code,
      values: values
    });
    return optionType !== 'swatch' ? SwatchList : TileList;
  };

  var _useOption = useOption({
    attribute_id: attribute_id,
    label: label,
    onSelectionChange: onSelectionChange,
    selectedValue: selectedValue,
    values: values
  }),
      handleSelectionChange = _useOption.handleSelectionChange,
      initialSelection = _useOption.initialSelection,
      selectedValueDescription = _useOption.selectedValueDescription;

  var ValueList = useMemo(function () {
    return getListComponent(attribute_code, values);
  }, [attribute_code, values]);
  return React.createElement("div", {
    className: "flex flex-col justify-between h-full"
  }, React.createElement("div", {
    className: classes.selectOptionsWrapper
  }), React.createElement("div", {
    className: ""
  }, React.createElement("div", {
    className: "mb-4"
  }, React.createElement(Button, {
    priority: "normal",
    fullWidth: true,
    classes: {
      content: classes.btn
    },
    "aria-label": "Reset default"
  }, "RESET DEFAULT")), React.createElement(Button, {
    priority: "low",
    fullWidth: true,
    classes: {
      content: classes.btn
    },
    "aria-label": "Confirm selection"
  }, "CONFIRM SELECTION")));
};

export default SelectedOptionsContent;